import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var SpeakerIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M20.97 15.757a1 1 0 01-.727 1.213c-.49.123-.98.234-1.47.335l-1.833 5.037a1 1 0 01-1.88-.684l1.444-3.965a33.26 33.26 0 01-9.007 0l1.443 3.965a1 1 0 01-1.88.684l-1.832-5.037c-.49-.1-.98-.212-1.47-.335a1 1 0 11.485-1.94C6.83 15.677 9.416 16 12 16c2.584 0 5.17-.323 7.757-.97a1 1 0 011.213.727zM13.364 10a4 4 0 014 4 1 1 0 01-2 0 2 2 0 00-1.851-1.995l-.15-.005h-2.727a2 2 0 00-2 2 1 1 0 01-2 0 4 4 0 013.8-3.995l.2-.005h2.728zM12 2a3.726 3.726 0 11-3.727 3.725A3.726 3.726 0 0112 2zm0 2a1.726 1.726 0 101.727 1.725C13.727 4.772 12.954 4 12 4z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
SpeakerIcon.isCarinaIcon = true;
export default SpeakerIcon;
